import { FC } from "react";
import { Contract as ContractType, Point } from "tm-shared/types";

import AddContract from "@/pages/WorkPlan/AboutPoint/InfoTab/AddContract";
import { PageBlock } from "@/shared/pageComposition/BlockList";

import { ContractCapabilities } from "./Contract.policy";
import { ContractView } from "./ContractView";

export type ContractModel = {
    capabilities: ContractCapabilities;
    contract: ContractType;
    fopName: string;
    contractTypeName: string;
    point: Point | null;
    editMode: boolean;
};

const ContractViewBlock: FC<{
    contract: ContractType;
    fopName: string;
    contractTypeName: string;
    point: Point | null;
}> = ({ contract, fopName, contractTypeName, point }) => (
    <ContractView
        contract={contract}
        fopName={fopName}
        contractTypeName={contractTypeName}
        point={point}
    />
);

const ContractEditBlock: FC<{
    contract: ContractType;
    fopName: string;
}> = ({ contract, fopName }) => (
    <AddContract editMode contract={contract} fop={fopName} />
);

export const getContractBlocks = (
    model: ContractModel,
): PageBlock<ContractModel>[] => [
    {
        key: "contract-view",
        order: 10,
        isVisible: (model) => !model.editMode,
        render: () => (
            <ContractViewBlock
                contract={model.contract}
                fopName={model.fopName}
                contractTypeName={model.contractTypeName}
                point={model.point}
            />
        ),
    },
    {
        key: "contract-edit",
        order: 20,
        isVisible: (model) => model.editMode,
        render: () => (
            <ContractEditBlock
                contract={model.contract}
                fopName={model.fopName}
            />
        ),
    },
];
